import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-margem-mo-filtro',
  templateUrl: './margem-mo-filtro.component.html',
  styleUrls: ['./margem-mo-filtro.component.css']
})
export class MargemMOFiltroComponent implements OnInit {

  @Input() filtros: any;

  constructor() { }

  ngOnInit() {
  }
}
